import React from "react";

const Spiner = ({className=""}) => {
    return (
        <span className={"loader "+className} />
    )
};

export default Spiner